import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf4766b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 mt-4 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Operatör:"),
    /*#__PURE__*/_createTextVNode(" NS (Nederlandse Spoorwegen)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Regionaltrafik:"),
    /*#__PURE__*/_createTextVNode(" Arriva, Breng, Connexxion m.fl. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Biljettinformation:"),
    /*#__PURE__*/_createTextVNode(" Ingen platsbokning krävs på vanliga tåg ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resebokning:"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.ns.nl",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "ns.nl")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Flexibilitet:"),
    /*#__PURE__*/_createTextVNode(" Inga platsreservationer krävs – bara hoppa på. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Reskort:"),
    /*#__PURE__*/_createTextVNode(" Interrail funkar bra, men dagbiljetter kan vara billigare vid kortare vistelser. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cyklar:"),
    /*#__PURE__*/_createTextVNode(" Cykelvänligt land – hyr cykel för att utforska städerna. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Språk:"),
    /*#__PURE__*/_createTextVNode(" De flesta talar utmärkt engelska.")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.ns.nl",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "NS – Nederlandse Spoorwegen")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.interrail.eu/en/plan-your-trip/trip-ideas/netherlands",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Interrail – Nederländerna")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://9292.nl/en",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "9292 – Resplanerare i Nederländerna")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.holland.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Holland.com – Officiell turism")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'NetherlandsGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).netherlandsGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Nederländerna",
      maxHeight: "60vh",
      backgroundImageClass: "background-netherlands"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Upptäck Nederländerna med tåg" }, {
            default: _withCtx(() => [
              _createTextVNode(" Nederländerna är ett litet men mångsidigt land som lämpar sig perfekt för tågluff. Här går tågen tätt och snabbt mellan charmiga städer, historiska platser och kustnära byar. Kombinationen av smidiga transporter, korta avstånd och levande kultur gör landet till en idealisk destination för både korta och längre tågresor. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Nederländerna" }, {
            default: _withCtx(() => [
              _createTextVNode(" Tågnätet i Nederländerna är ett av Europas mest effektiva. Tågen går ofta, punktligt och når även mindre orter. Interrailkortet gäller på alla tåg från NS och de flesta andra operatörer. "),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(ListCard, {
            title: "Förslag på tågrutter i Nederländerna",
            items: [
					{
						title: 'Klassiska Holland',
						description: 'Amsterdam → Utrecht → Rotterdam → Haag',
						link: '',
					},
					{
						title: 'Kust och konst',
						description: 'Leiden → Haarlem → Zandvoort',
						link: '',
					},
					{
						title: 'Norr till syd',
						description: 'Groningen → Zwolle → Eindhoven → Maastricht',
						link: '',
					},
					{
						title: 'Historisk runda',
						description: 'Delft → Gouda → Amersfoort',
						link: '',
					},
				]
          }),
          _createVNode(GridCard, {
            title: "Destinationer i Nederländerna",
            items: [
					{
						title: 'Amsterdam',
						image: '🚲',
						description:
							'Kanaler, museer och livlig atmosfär – ett måste på varje resa.',
						link: '/guider/destinationer/nederländerna/amsterdam',
					},
					{
						title: 'Rotterdam',
						image: '🏙️',
						description:
							'Modern arkitektur och spännande matupplevelser vid vattnet.',
						link: '/guider/destinationer/nederländerna/rotterdam',
					},
					{
						title: 'Utrecht',
						image: '⛪',
						description: 'Historisk stadskärna med vackra kanaler och kaféliv.',
						link: '/guider/destinationer/nederländerna/utrecht',
					},
					{
						title: 'Maastricht',
						image: '🧀',
						description:
							'Sydeuropeisk känsla nära Belgien – historia och studentliv.',
						link: '/guider/destinationer/nederländerna/maastricht',
					},
					{
						title: 'Leiden',
						image: '🎓',
						description:
							'Universitetsstad med blomsterfält, kanaler och charm.',
						link: '/guider/destinationer/nederländerna/leiden',
					},
					{
						title: 'Groningen',
						image: '🎨',
						description: 'Ung och energisk stad med konst, cyklar och kultur.',
						link: '/guider/destinationer/nederländerna/groningen',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(TextBlock, { header: "Tips för tågluffare i Nederländerna" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resurser" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})